<template>
    <div class="row">
      <div class="col-12 card">
        <h4>Список договоров</h4>
        <div class="row justify-content-space-between top-24">
            <div class="col-12">
              <div class="row justify-content-space-between">
                <ContractsList/>
              </div>
            </div>
        </div>

      </div>
    </div>
</template>
  
  <script>
    import ContractsList from "@/components/Polygon/Contracts/ContractsList.vue";
  
    export default {
      components: { ContractsList },
      data() {
        return {
          title: "Список договоров",
        }
      },
      computed: {

      },
    };
  </script>
  